import React from 'react';
import { useModalState } from 'hooks/modals';
import { LogoutIcon_24 } from 'assets/icons';
import LogoutModal from './LogoutModal';
import messages from './LogoutButton.messages';
import styles from './LogoutButton.module.css';

const LogoutButton = (): JSX.Element => {
  const { closeModal, openModal, isModalVisible } = useModalState();
  return (
    <React.Fragment>
      <button className={styles.logoutButton} onClick={openModal} title={messages.logout}>
        <LogoutIcon_24 />
        {messages.logout}
      </button>
      <LogoutModal onRequestClose={closeModal} isOpen={isModalVisible} />
    </React.Fragment>
  );
};

export default LogoutButton;
